var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"width-200"},[_vm._v("\n    "+_vm._s(_vm.addressDetails)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }